// application entry file
import * as React from 'react';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import ReactDOM from 'react-dom/client';
import 'navigator.sendbeacon';
import { initializeDatadogRUM } from 'config/datadog/initializeDatadogRUM';

import { App } from './App';
import './index.css';

// RUM must initialize before the React tree mounts and data fetching starts so
// load timings are measured from navigationStart; events are buffered until
// cookie consent is granted.
initializeDatadogRUM();

dayjs.extend(utc);

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('root');
  const root = ReactDOM.createRoot(container!);
  root.render(<App />);
});
